import { getTotal } from "./helpers";

export const FooterConfig = (data, footerType, policyNo) => {
  let footerData;
  switch (footerType) {
    case "rating":
      if (localStorage.getItem(`isRecalculate-${policyNo}`) === null) {
        data.details.ratingCarList = data.content;
        localStorage.setItem(
          `footerSummary-${policyNo}`,
          JSON.stringify(data.details),
        );
        footerData = data.details;
      } else {
        let ratingInfo = JSON.parse(
          localStorage.getItem(`footerSummary-${policyNo}`),
        );
        data.content = ratingInfo.ratingCarList;
        data.details.ratingCarList = ratingInfo.ratingCarList;
        footerData = ratingInfo;
      }

      break;
    case "summary":
      if (data && data.details) {
        localStorage.setItem(
          `summary-${policyNo}`,
          JSON.stringify(data.details),
        );
      } else {
        localStorage.removeItem(`summary-${policyNo}`);
      }
      break;
    case "history":
      if (data && data.details) {
        localStorage.setItem("historyTotal", JSON.stringify(data.details));
      } else {
        localStorage.removeItem("historyTotal");
      }
      break;
    case "paymentList":
      if (data && data.details) {
        localStorage.setItem(
          `paymentList-${policyNo}`,
          JSON.stringify(data.details),
        );
      } else {
        localStorage.removeItem(`paymentList-${policyNo}`);
      }
      break;
    case "moneyBatch":
      if (data && data.content) {
        localStorage.setItem(`moneyBatch`, getTotal(data.content));
      } else {
        localStorage.removeItem(`moneyBatch`);
      }
      break;
    case "claimsView":
      if (data && data.details) {
        localStorage.setItem(`claimsCheck`, JSON.stringify(data.details));
      } else {
        localStorage.removeItem(`claimsCheck`);
      }
      break;
    default:
      break;
  }
  return footerData;
};
